import { render, staticRenderFns } from "./full.vue?vue&type=template&id=51a04006&scoped=true&"
import script from "./full.vue?vue&type=script&lang=ts&"
export * from "./full.vue?vue&type=script&lang=ts&"
import style0 from "./full.vue?vue&type=style&index=0&id=51a04006&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a04006",
  null
  
)

export default component.exports